<div class="form-field">
  <span class="form-field-label">
    {{ label }}<span *ngIf="isRequired()" class="required"> *</span>
  </span>
  <mat-select
    multiple
    [formControl]="form"
    [placeholder]="placeholder"
    (selectionChange)="onChange()"
  >
    <mat-select-trigger>
      {{ triggerText() }}
    </mat-select-trigger>
    <mat-checkbox
      disableRipple
      [indeterminate]="isIndeterminate()"
      [checked]="isChecked()"
      (change)="toggleSelection($event)"
      class="mat-option"
      >{{ allLabel }}</mat-checkbox
    >
    <mat-option *ngFor="let option of options" [value]="option.value">{{
      option.name
    }}</mat-option>
  </mat-select>
</div>
<ng-container *ngIf="form.invalid && (form.dirty || form.touched)">
  <mat-error *ngIf="form.hasError('required')">{{ placeholder }}</mat-error>
</ng-container>
